var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.href ? "a" : _vm.tag,
    {
      tag: "component",
      staticClass: "z-caption",
      class: _vm.classObject,
      style: "line-height: " + _vm.lineHeight,
      attrs: { href: _vm.href },
    },
    [
      _vm._t("left-icon"),
      _vm._v(" "),
      _c("span", { staticClass: "z-caption__text" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.href
        ? _c(
            "span",
            { staticClass: "z-caption__arrow" },
            [_c("z-icon", { attrs: { name: "arrow_bold", dir: "right" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("right-icon"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }